import {Component, Input} from '@angular/core';
import {MarkdownComponent} from '../../../../../shared/components/markdown/markdown.component';
import {AssetVersionPipe} from '../../../../../pipes/asset-version.pipe';
import {NgFor, NgIf} from '@angular/common';
import {WebInsight, WebInsights} from '../../../types';

@Component({
  selector: 'app-copilot-web-insights-message',
  imports: [
    MarkdownComponent,
    NgIf,
    NgFor,
    AssetVersionPipe
  ],
  templateUrl: './copilot-web-insights-message.component.html',
  styleUrl: './copilot-web-insights-message.component.scss'
})
export class CopilotWebInsightsMessageComponent {
  @Input() webInsights: WebInsights | string | undefined;

  get isLegacy(): boolean {
    if (typeof this.webInsights !== 'string') return false;
    try {
      const parsed = JSON.parse(this.webInsights);
      return !Array.isArray(parsed);
    } catch {
      return true;
    }
  }

  get legacyContent(): string {
    return this.webInsights as string;
  }

  get insightItems(): WebInsight[] {
    if (Array.isArray(this.webInsights)) return this.webInsights;
    if (typeof this.webInsights === 'string') {
      try {
        const parsed = JSON.parse(this.webInsights);
        if (Array.isArray(parsed)) return parsed;
      } catch {}
    }
    return [];
  }
}
